import { useEffect, useState } from 'react';
import { subscribe, getDb } from './dataService';
import { DbDatabase } from './types';

/**
 * Подписка на изменения DB. Любой компонент, читающий через хук,
 * перерисуется при изменении таблиц. React 17-совместимо.
 */
export const useDb = (): DbDatabase => {
  const [, setTick] = useState(0);
  useEffect(() => subscribe(() => setTick((v) => v + 1)), []);
  return getDb();
};
